module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","positiveImpacts":"Positive Impacts","negativeImpacts":"Negative Impacts","status":"Status","risks":"Risks","opportunities":"Opportunities","comment":"Comment"},"de":{"name":"Name","positiveImpacts":"Positive Auswirkungen","negativeImpacts":"Negative Auswirkungen","status":"Status","risks":"Risiken","opportunities":"Chancen","comment":"Kommentar"}}')
  delete Component.options._Ctor
}
